import { AgGridTable } from 'components/AgGrid/AgGridTable';
import type { ContractStatusEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { useSelection } from 'hooks/useSelection';
import type { AnyObject } from 'types/AnyObject';

import type { ColDef } from 'ag-grid-community';
import type React from 'react';
import { useMemo, useState } from 'react';

import { getBimWorkOrderRowClass } from '../BimWorkOrderPriceTable/cellRenderers';

import { ActsKc2TopPanel } from './components/ActsKc2TopPanel';
import { useBimActsKc2Columns } from './hooks';
import type { BimActKc2DataExtended } from './types';

interface IBimWorkOrderActsKc2List {
    baseRow: AnyObject[];
    workOrderPriceId: number;
    actKC2data: BimActKc2DataExtended[];
    refreshActsKc2Data: () => void;
    setCheckedActForDetails: React.Dispatch<React.SetStateAction<BimActKc2DataExtended | null>>;
    defaultColDef?: ColDef;
    styleClass?: string;
    workOrderStatus?: WorkOrderStatusEnum;
    contractStatus?: ContractStatusEnum;
}

export const BimActsKc2List = (props: IBimWorkOrderActsKc2List) => {
    const {
        actKC2data,
        refreshActsKc2Data,
        workOrderPriceId,
        baseRow,
        defaultColDef,
        styleClass,
        workOrderStatus,
        contractStatus,
        setCheckedActForDetails,
    } = props;

    const [checkedIds, setCheckedIds] = useState<number[]>([]);

    const mappedBaseRow = useMemo(
        () => [{ ...baseRow[0], value: baseRow[0].completedValue, number: baseRow[0].completedValue.name }],
        [baseRow],
    );

    const columns = useBimActsKc2Columns({
        checkedIds,
        workOrderStatus,
        contractStatus,
        setCheckedIds,
        setCheckedActForDetails,
    });

    const [selection, , , setSelection] = useSelection('bimWorkOrderActKc2');

    const columnsToShow = useMemo(
        () =>
            Object.keys(selection).length ? columns.filter((c) => !c.headerName || selection[c.headerName]) : columns,
        [columns, selection],
    );

    const settingColumns = useMemo(() => columns.filter((_, i) => !!i), [columns]);

    return (
        <div className={`ag-theme-alpine ${styleClass}`}>
            <ActsKc2TopPanel
                workOrderPriceId={workOrderPriceId}
                checkedIds={checkedIds}
                setCheckedIds={setCheckedIds}
                refreshData={refreshActsKc2Data}
                columns={settingColumns}
                columnsSelection={selection}
                onColumnsSelectionChange={setSelection}
            />
            <AgGridTable
                pinnedTopRowData={mappedBaseRow}
                rowData={actKC2data}
                columnDefs={columnsToShow}
                tooltipShowDelay={200}
                defaultColDef={defaultColDef}
                rowClassRules={getBimWorkOrderRowClass}
                containerStyle={{ paddingBottom: 20, height: 458 }}
                overlayNoRowsTemplate="Нет данных"
            />
        </div>
    );
};

BimActsKc2List.displayName = 'BimActsKc2List';
